import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import portfolioService from '../../services/portfolioService';
import PortfolioCard from './PortfolioCard';
import './PortfolioList.css';
import { FaIndianRupeeSign } from 'react-icons/fa6';
import CommonModal from '../../services/CommonModal';
import PortfolioListView from './PortfolioListView';

const PortfolioList = () => {
  const [portfolios, setPortfolios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [viewMode, setViewMode] = useState('grid'); // 'grid' or 'tree'

  const [filters, setFilters] = useState({
    search: '',
    status: '',
    is_active: '',
    owner_id: ''
  });
  const [stats, setStats] = useState({
    total: 0,
    active: 0,
    totalBudget: 0,
    totalSpent: 0,
    totalProjects: 0
  });

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    fetchPortfolios();
  }, [filters]);

  const fetchPortfolios = async () => {
    try {
      setLoading(true);
      const data = await portfolioService.getAllPortfolios({
        ...filters,
        include_stats: 'true'
      });

      setPortfolios(data.portfolios || []);

      if (data.stats) {
        setStats({
          total: data.stats.total_portfolios || 0,
          active: data.stats.active_portfolios || 0,
          totalBudget: data.stats.total_budget_allocated || 0,
          totalSpent: data.stats.total_budget_spent || 0,
          totalProjects: data.stats.total_projects || 0
        });
      }

      setError(null);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to fetch portfolios');
      setPortfolios([]);
    } finally {
      setLoading(false);
    }
  };


  const confirmDelete = () => {
    if (selectedId) {
      handleDelete(selectedId); // your existing delete API/function
    }

    setShowDeleteModal(false);
    setSelectedId(null);
  };

  const handleDeleteClick = (id) => {
    setSelectedId(id);
    setShowDeleteModal(true);
  };



  const handleDelete = async (id) => {
    // if (!window.confirm('Are you sure you want to delete this portfolio?')) {
    //   return;
    // }

    try {
      await portfolioService.deletePortfolio(id);
      fetchPortfolios();
    } catch (err) {
      alert(err.response?.data?.error || 'Failed to delete portfolio');
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const budgetUtilization = stats.totalBudget > 0
    ? ((stats.totalSpent / stats.totalBudget) * 100).toFixed(2)
    : 0;

  return (
    <div className="portfolio-list-container">
      <div className="portfolio-list-header">
        <h1>Portfolios</h1>
        <Link to="/app/portfolios/new" className="btn btn-primary">
          <i className="fas fa-plus"></i> Create Portfolio
        </Link>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}

      {/* Statistics Cards */}
      <div className="stats-grid">
        <div className="stat-card portfolio-direction" >
          <div className="stat-icon" style={{ backgroundColor: '#e3f2fd' }}>
            <i className="fas fa-briefcase" style={{ color: '#fff' }}></i>
          </div>
          <div className="stat-content">
            <div className="stat-value no-background ">{stats.total}</div>
            <div className="stat-label">Total Portfolios</div>
          </div>
        </div>

        <div className="stat-card portfolio-direction" >
          <div className="stat-icon" style={{ backgroundColor: '#e8f5e9' }}>
            <i className="fas fa-check-circle" style={{ color: '#fff' }}></i>
          </div>
          <div className="stat-content">
            <div className="stat-value no-background">{stats.active}</div>
            <div className="stat-label">Active Portfolios</div>
          </div>
        </div>

        <div className="stat-card portfolio-direction" >
          <div className="stat-icon" style={{ backgroundColor: '#f3e5f5' }}>
            <i className="fas fa-project-diagram" style={{ color: '#fff' }}></i>
          </div>
          <div className="stat-content">
            <div className="stat-value no-background ">{stats.totalProjects}</div>
            <div className="stat-label">Total Projects</div>
          </div>
        </div>

        <div className="stat-card portfolio-direction" >
          <div className="stat-icon" style={{ backgroundColor: '#fff3e0' }}>
            <FaIndianRupeeSign style={{ color: '#fff' }} />
          </div>
          <div className="stat-content">
            <div className="stat-value no-background">
              {portfolioService.formatBudget(stats.totalBudget)}
            </div>
            <div className="stat-label">Total Budget</div>
          </div>
        </div>

        <div className="stat-card portfolio-direction" >
          <div className="stat-icon" style={{ backgroundColor: '#fce4ec' }}>
            <i className="fas fa-chart-line" style={{ color: '#fff' }}></i>
          </div>
          <div className="stat-content">
            <div className="stat-value no-background">{budgetUtilization}%</div>
            <div className="stat-label">Budget Utilization</div>
          </div>
        </div>
      </div>

      {/* Filters */}
      <div className="controls-section">
        <div className="filters filter-custom">
          <div className="filter-group">
            <input
              type="text"
              name="search"
              className="form-control filter-custom"
              placeholder="Search portfolios..."
              value={filters.search}
              onChange={handleFilterChange}
            />
          </div>

          <div className="filter-group">
            <select
              name="status"
              className="form-control"
              value={filters.status}
              onChange={handleFilterChange}
            >
              <option value="">All Status</option>
              <option value="Planning">Planning</option>
              <option value="Active">Active</option>
              <option value="On Hold">On Hold</option>
              <option value="Completed">Completed</option>
              <option value="Cancelled">Cancelled</option>
            </select>
          </div>

          <div className="filter-group">
            <select
              name="is_active"
              className="form-control"
              value={filters.is_active}
              onChange={handleFilterChange}
            >
              <option value="">All Active Status</option>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </select>
          </div>
        </div>

      </div>

      <div className="view-toggle mb-4">
        <button
          className={`toggle-btn ${viewMode === 'grid' ? 'active' : ''}`}
          onClick={() => setViewMode('grid')}
        >
          <i className="fas fa-th"></i> Grid View
        </button>
        <button
          className={`toggle-btn ${viewMode === 'tree' ? 'active' : ''}`}
          onClick={() => setViewMode('tree')}
        >
          <i className="fas fa-sitemap"></i> List View
        </button>
      </div>


      {loading && portfolios.length === 0 ? (
        <div className="loading">Loading portfolios...</div>
      ) : portfolios.length === 0 ? (
        <div className="no-portfolios">
          <i className="fas fa-briefcase"></i>
          <p>No portfolios found</p>
          <Link to="/app/portfolios/new" className="btn btn-primary">
            Create Your First Portfolio
          </Link>
        </div>
      ) : viewMode === "grid" ? (
        <div className="portfolios-grid">
          {portfolios.map((portfolio) => (
            <PortfolioCard
              key={portfolio.id}
              portfolio={portfolio}
              onDelete={() => handleDeleteClick(portfolio.id)}
            />
          ))}
        </div>
      ) : (
        <PortfolioListView
          portfolios={portfolios}
          onDelete={handleDeleteClick}
        />
      )}



      {/* Content */}
      {/* {loading && portfolios.length === 0 ? (
        <div className="loading">Loading portfolios...</div>
      ) : portfolios.length === 0 ? (
        <div className="no-portfolios">
          <i className="fas fa-briefcase"></i>
          <p>No portfolios found</p>
          <Link to="/app/portfolios/new" className="btn btn-primary">
            Create Your First Portfolio
          </Link>
        </div>
      ) : (
        <div className="portfolios-grid">
          {portfolios.map(portfolio => (
            <PortfolioCard
              key={portfolio.id}
              portfolio={portfolio}
              onDelete={() => handleDeleteClick(portfolio.id)}
            />
          ))}
        </div>
      )} */}
      <CommonModal
        isOpen={showDeleteModal}
        title="Delete Portfolio"
        message="Are you sure you want to delete this portfolio?"
        onClose={() => {
          setShowDeleteModal(false);
          setSelectedId(null);
        }}
        onConfirm={confirmDelete}
        type="error"
        confirmText="Delete"
        cancelText="Cancel"
      />
    </div>






  );
};






export default PortfolioList;

